<h1 mat-dialog-title>{{ data.title }}</h1>

<mat-dialog-content>{{ data.body }}</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" (click)="close()">{{ data.dialog_close_button }}</button>
</mat-dialog-actions>
